import coursepage_background from "../../assests/home2.webp";
import Header from '../componets/header/header';
import Footer from '../componets/footer/footer';
import './Coursepage.css';
import home1 from "../../assests/home1.webp";
import home2 from "../../assests/home2.webp";
import home3 from "../../assests/about_image.webp";
import { Button } from "antd";
function Coursepage() {
    return (
        <div className="coursepage">
            <Header />
            <div className="coursepage-hero">
                <img src={coursepage_background} alt="background" className="coursepage-background" />

                <div className="coursepage-overlay">
                    <h3>START TO LEARN TODAY</h3>
                    <h1>Explore Careers With PAPA DIGITAL SOLUTION</h1>

                    <div className="course-cards-wrapper">
                        <div className="course-card">
                            <h4>PAPA For Advertisers</h4>
                            <ul>
                                <li>Agency Based Digital Marketing Course</li>
                                <li>Live Online Digital Marketing Session</li>
                                <li>Evening Weekend Batch</li>
                            </ul>
                        </div>
                        <div className="course-card">
                            <h4>PAPA For Creators</h4>
                            <ul>
                                <li>Design and Photography</li>
                                <li>Video Creation & Motion Graphics</li>
                            </ul>
                        </div>
                        <div className="course-card">
                            <h4>Placements</h4>
                            <p>Crack your dream career with our placement opportunity and pave the way to success</p>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="internship-card-section">
                    <div className="internship-card dark">
                        <div className="internship-card-content">

                            <h3>Digital Marketing Course</h3>
                            <p>
                                Learn SEO, social media, paid ads, and analytics with real-world projects. Gain hands-on experience from one of the top digital marketing academies in Kochi.
                            </p>
                            <Button href="/internship" className="hoverEffect">
                                Read More                            </Button>
                        </div>
                    </div>

                    <div className="internship-card light">
                        <div className="internship-card-content">

                            <h3>Online Live Digital Marketing Program</h3>
                            <p>
                                Understand how to build and position brands effectively. Develop your creative and strategic thinking through guided mentorship.
                            </p>
                            <Button href="/internship" className="hoverEffect">
                                Read More                            </Button>
                        </div>
                    </div>

                    <div className="internship-card dark">
                        <div className="internship-card-content">
                            <h3>On-Site Digital Marketing</h3>
                            <p>
                                Learn SEO, social media marketing, Google Ads, email campaigns, and analytics through live projects. Build in-demand skills with real-time, in-house training.
                            </p>
                            <Button href="/Internshiponsite" className="hoverEffect">
                                Read More                            </Button>
                        </div>
                    </div>
                    {/* Advance Digital Marketing - 3 Months */}
                    <div className="internship-card dark">
                        <div className="internship-card-content">
                            <h3>Advanced Digital Marketing (3 Months)</h3>
                            <p>
                                Master SEO, Google Ads, social media marketing, content strategy, and advanced analytics. This program includes certification and hands-on project experience.
                            </p>
                            <Button href="/internship" className="hoverEffect">
                                Read More
                            </Button>
                        </div>
                    </div>

                    {/* Graphic Designing */}
                    <div className="internship-card dark">
                        <div className="internship-card-content">
                            <h3>Graphic Designing</h3>
                            <p>
                                Learn Photoshop, Illustrator, and Canva to create visual content for branding, marketing, and social media. Build your portfolio with creative projects.
                            </p>
                            <Button href="/internshipgraphics" className="hoverEffect">
                                Read More
                            </Button>
                        </div>
                    </div>

                    {/* Website Development Using Coding */}
                    <div className="internship-card dark">
                        <div className="internship-card-content">
                            <h3>Website Development Using Coding</h3>
                            <p>
                                Learn HTML, CSS, JavaScript, and React to build responsive websites from scratch. Work on real-world projects and understand modern web development practices.
                            </p>
                            <Button href="/InternshipCoding" className="hoverEffect">
                                Read More
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Coursepage;
